function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h746v80H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.929 17.052A9.952 9.952 0 010 9.989 9.994 9.994 0 0110 0h695.956a9.973 9.973 0 017.071 2.926l30.044 30.011a9.981 9.981 0 010 14.126l-30.044 30.011A9.973 9.973 0 01705.956 80L10 79.912a9.994 9.994 0 01-10-9.989 9.952 9.952 0 012.929-7.063l15.838-15.849a9.969 9.969 0 000-14.11z",
  fill: "#666"
});

function SvgInd666(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 746 80"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3NDYgODAiPjxyZWN0IHdpZHRoPSI3NDYiIGhlaWdodD0iODAiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJNLTE1OS41NzEsNDYuMDUyYTkuOTUyLDkuOTUyLDAsMCwxLTIuOTI5LTcuMDYzQTkuOTk0LDkuOTk0LDAsMCwxLTE1Mi41LDI5SDU0My40NTZhOS45NzMsOS45NzMsMCwwLDEsNy4wNzEsMi45MjZsMzAuMDQ0LDMwLjAxMWE5Ljk4MSw5Ljk4MSwwLDAsMSwwLDE0LjEyNmwtMzAuMDQ0LDMwLjAxMUE5Ljk3Myw5Ljk3MywwLDAsMSw1NDMuNDU2LDEwOWwtNjk1Ljk1Ni0uMDg4YTkuOTk0LDkuOTk0LDAsMCwxLTEwLTkuOTg5LDkuOTUyLDkuOTUyLDAsMCwxLDIuOTI5LTcuMDYzbDE1LjgzOC0xNS44NDlhOS45NjksOS45NjksMCwwLDAsMC0xNC4xMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2Mi41IC0yOSkiIGZpbGw9IiM2NjYiLz48L3N2Zz4K";
export { SvgInd666 as ReactComponent };